import { createAction } from 'redux-actions'

export const VCCFItemsFetchStart = createAction('static/vccf/FETCH_ITEMS_START')
export const VCCFItemsFetchSuccess = createAction('static/vccf/FETCH_ITEMS_SUCCESS')
export const VCCFITEMSFetchFail = createAction('static/vccf/FETCH_ITEMS_FAIL')
export const VCCFSubmit = createAction('static/vccf/SUBMIT')
